export const UNREAD_COUNT = 'unreadCount';
export const NOTIFICATION_LIST = 'notificationList';
export const IS_NOT_DISTURB = 'isNotDisturb';
